const money = (value) => Number.isFinite(Number(value))
  ? Math.round(Math.max(0, Number(value)) * 100) / 100 : 0;

// Promotions remain in the price; only the owner's discretionary discount is
// added back. This helper is for display; the server validates payable fees.
export const commissionBaseBeforeLocalDiscount = (pricing, grossAmount) =>
  money(money(grossAmount ?? pricing?.finalTotal) + money(pricing?.manualDiscount?.amount));

export const readDiscountCommissionQuote = async (admin, branchId, orderIds, grossAmount, commissionRate) => {
  const { data, error } = await admin.rpc("get_discount_commission_quote", {
    p_branch_id: branchId, p_order_ids: orderIds,
    p_gross_amount: grossAmount, p_rate: commissionRate,
  });
  if (error || !data || !Number.isFinite(data.baseAmount) || data.baseAmount < grossAmount ||
      !Number.isFinite(data.commissionAmount) || data.commissionAmount < 0 ||
      !Number.isFinite(data.commissionRate) || data.commissionRate < 0 || data.commissionRate > 0.25) {
    throw new Error("No pudimos validar la base de la comision. No se genero el cobro.");
  }
  return data;
};

export const preserveExistingCommissionQuote = (quote, intent, chargedAmount) => {
  if (!intent) return quote;
  const storedGross = Number(intent.metadata?.chargedAmount ?? intent.gross_amount);
  const storedBase = Number(intent.metadata?.commissionBaseAmount ?? intent.gross_amount);
  const rate = Number(intent.commission_rate);
  const fee = Number(intent.current_commission_amount);
  if (!Number.isFinite(storedGross) || Math.abs(storedGross - chargedAmount) > 0.01) {
    throw new Error("El total cambio. Cancela el cobro anterior antes de generar uno nuevo.");
  }
  if (!Number.isFinite(storedBase) || storedBase < 0 || !Number.isFinite(rate) || rate < 0 || rate > 0.25 ||
      !Number.isFinite(fee) || fee < 0) {
    throw new Error("No pudimos validar la comision del cobro anterior.");
  }
  return { baseAmount: storedBase, commissionRate: rate, commissionAmount: fee };
};
